import {match} from 'ts-pattern';

import type {InterestLeadQuality} from '@prompt-bridge/shared/ai-assistant-core';

export const toInterestLeadQuality = (leadQuality: string | null | undefined) =>
  match(leadQuality)
    .returnType<InterestLeadQuality | null>()
    .with('cold', 'warm', 'hot', 'unqualified', (quality) => quality)
    .otherwise(() => null);
